module.exports = __webpack_public_path__ + "img/011_maurer.a8ab46dc.jpg";